import * as React from "react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import { IfPermitted } from "components/common";
import { InputForm } from "components/inputs";
import useInputMutations from "hooks/useInputMutations";
import useInputTypesDescriptions from "hooks/useInputTypesDescriptions";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const StyledButton = styled(Button)(
  ({ theme }) => css`
    margin-right: ${theme.spacings.md};
  `
);
const EditInputButton = ({ input }) => {
  const { t } = useTranslation("inputs");
  const [showConfigurationForm, setShowConfigurationForm] = useState(false);
  const { data: inputTypeDescriptions } = useInputTypesDescriptions();
  const { updateInput } = useInputMutations();
  const sendTelemetry = useSendTelemetry();
  const definition = inputTypeDescriptions == null ? void 0 : inputTypeDescriptions[input.type];
  const editInput = () => {
    setShowConfigurationForm(true);
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_EDIT_CLICKED, {
      app_action_value: "edit-input"
    });
  };
  const handleInputUpdate = async (inputData) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_UPDATED, {
      app_action_value: "input-edit"
    });
    await updateInput({ input: inputData, inputId: input.id });
  };
  return /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`inputs:edit:${input.id}`, `input_types:create:${input.type}`] }, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: "primary", onClick: editInput, disabled: definition === void 0 }, t("edit_input.edit")), definition && showConfigurationForm && /* @__PURE__ */ React.createElement(
    InputForm,
    {
      setShowModal: setShowConfigurationForm,
      key: `edit-form-input-${input.id}`,
      globalValue: input.global,
      nodeValue: input.node,
      configFields: definition.requested_configuration,
      description: definition == null ? void 0 : definition.description,
      title: t("edit_input.editing", { title: input.title }),
      titleValue: input.title,
      typeName: input.type,
      includeTitleField: true,
      handleSubmit: handleInputUpdate,
      submitButtonText: t("edit_input.update"),
      values: input.attributes
    }
  ));
};
export default EditInputButton;
